export default "__VITE_ASSET__ORgOs2A6mYI8zc5N1U1L8w__"